import React, { useEffect, useRef, useState } from 'react'
import Cookies from 'js-cookie'
import Loading from '../Loading/Loading'
import OptionalCookieMessage from "../OptionalCookieMessage/OptionalCookieMessage";
import {GalleryItem, GalleryItemType} from "./models/GalleryItem";

interface GalleryActiveItemProps {
    activeImage: GalleryItem;
}

const GalleryActiveItem = (props:GalleryActiveItemProps) => {

    const [FadeIn, setFadeIn] = useState(false)
    const [cookiesEnabled, setCookiesEnabled] = useState(false)
    const [currentImage, setCurrentImage] = useState<GalleryItem>(undefined)
    const [imageIsLoaded, setImageIsLoaded] = useState(false)
    const [isInitialItem, setIsInitialItem] = useState(true)
    
    const prevProps = useRef(props);
    //Same as componentDidUpdate
    useEffect(() => {
        setImageIsLoaded(false);
        setIsInitialItem(false);
        
        if (typeof prevProps.current.activeImage !== 'undefined' && prevProps.current.activeImage !== props.activeImage) {
            setFadeIn(true);
        }

        prevProps.current = props;
        
        setCookiesEnabled(Cookies.get("optoma_cookie_preference") === 'true')
        
        if(props.activeImage.itemType === GalleryItemType.image) {
            const img = new Image();
            img.onload = () => {
                setImageIsLoaded(true);
                setCurrentImage(props.activeImage)
            }
            img.src = props.activeImage.originalUrl;
        } else {
            //For videos, do not try to load them as an image, just set the image as loaded
            setImageIsLoaded(true);
            setCurrentImage(props.activeImage)
        }
    }, [props])

    //Initial render only
    useEffect(() => {
        setCurrentImage(props.activeImage)
        setImageIsLoaded(true)
    }, []);

    if(currentImage === undefined) {
        return <div>Loading initial image...</div>
    }
    
    return (
        <div className="active-image">
            {!imageIsLoaded &&
                <div className="loading"><Loading /></div>
            }
            
            {currentImage.itemType == GalleryItemType.image &&
                <img key={props.activeImage.originalUrl} src={currentImage.originalUrl} alt={currentImage.altText} />
            }

            {currentImage.itemType == GalleryItemType.ytvideo &&
                <div className="gallery-video-container">

                    {cookiesEnabled &&
                        <div className="youtubeflexicontainer">
                            <iframe
                                className="youtubeflexivid"
                                allowFullScreen
                                src={`https://www.youtube-nocookie.com/embed/${currentImage.originalUrl}?hd=1&rel=0&modestbranding=1&autohide=1&showinfo=0&wmode=opaque&controls=1&autoplay=${!isInitialItem}`}
                            />
                        </div> }

                    {!cookiesEnabled &&
                        <OptionalCookieMessage />
                    }
                </div>
            }

            {currentImage.itemType == GalleryItemType.vimeo &&
                <div className="gallery-video-container">
                    {cookiesEnabled &&
                        <iframe
                            className="vimeo"
                            src={`https://player.vimeo.com/video/${currentImage.originalUrl}`}
                            height="500"
                            allowFullScreen/>
                    }

                    {!cookiesEnabled &&
                        <OptionalCookieMessage />
                    }
                </div>
            }
        </div>
    )
}

export default GalleryActiveItem;